import { ViewController } from '@estee/elc-service';
import { action } from 'mobx';
import { StoreDetailsClickedUseCase } from '~use-cases/StoreDetailsClickedUseCase';
import { BookAppointmentClickedUseCase } from '~use-cases/BookAppointmentClickedUseCase';
import { events, emit } from '@estee/elc-service-bus';

export class StoreListItemActionsViewController extends ViewController {
    @action
    public onBookAppointment = (counterId: string, storeName: string) => {
        emit(events.STORE_BOOK_APPOINTMENT_LINK_CLICKED, {
            eventName: 'store_finder',
            eventCategory: 'store_finder_store_selection',
            eventAction: storeName,
            eventLabel: 'book_a_service'
        });
        new BookAppointmentClickedUseCase(counterId, storeName).execute();
    };

    @action
    public onViewStoreDetail = (name: string, id: string) => {
        emit(events.STORE_DETAILS_LINK_CLICKED, {
            eventName: 'store_finder',
            eventCategory: 'store_finder_store_selection',
            eventAction: name,
            eventLabel: 'store_details'
        });
        new StoreDetailsClickedUseCase(id, name).execute();
    };
}
